import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import PhotoLightbox from './PhotoLightbox'
import { photos } from '../../data/photos'

export default function PhotoGallery() {
  const [selectedPhoto, setSelectedPhoto] = useState(null)

  return (
    <>
      {/* Masonry-style grid */}
      <div className="columns-1 sm:columns-2 lg:columns-3 gap-3 sm:gap-4 lg:gap-6 px-2 sm:px-0">
        {photos.map((photo, index) => (
          <motion.div
            key={photo.id}
            className="break-inside-avoid mb-3 sm:mb-4 lg:mb-6"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.15, duration: 0.6 }}
          >
            <motion.div
              className="relative group cursor-pointer overflow-hidden rounded-xl"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => setSelectedPhoto(photo)}
            >
              {/* Image */}
              <img
                src={photo.src}
                alt={photo.alt}
                className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />

              {/* Hover Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-dark-primary/80 via-dark-primary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-4">
                  <p className="text-white font-medium text-sm sm:text-base">
                    {photo.caption}
                  </p>
                </div>
              </div>

              {/* Pink glow ring on hover */}
              <div className="absolute inset-0 ring-2 ring-primary-pink/0 group-hover:ring-primary-pink/50 rounded-xl transition-all duration-300" />

              {/* Expand icon */}
              <motion.div
                className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-dark-primary/60 backdrop-blur-sm rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                whileHover={{ scale: 1.1 }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4 text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
                  />
                </svg>
              </motion.div>
            </motion.div>
          </motion.div>
        ))}
      </div>

      {/* Lightbox */}
      <AnimatePresence>
        {selectedPhoto && (
          <PhotoLightbox
            photo={selectedPhoto}
            onClose={() => setSelectedPhoto(null)}
          />
        )}
      </AnimatePresence>
    </>
  )
}
